class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/sms/provider/all'
			},
			addProvider: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sms/provider/add'
			},
			editProvider: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sms/provider/update'
			},
			deleteProvider: {
				headers: {
					'xt-user-token': null
				},
				method: 'delete',
				path: '/sms/provider/delete/:id'
			},
			fetchOnboarded: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sms/client/all'
			},
			onboard: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sms/client/add'
			},
			editClient: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sms/client/update'
			},
			fetchMasking: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sms/client/masking/all'
			},
			addMasking: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sms/client/masking/add'
			},
			updateMasking: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sms/client/masking/update'
			},
			send: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sms/send'
			},
			fetchReport: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sms/messages'
			},
			smsTemplate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/get/sms/template'
			},
			deleteSmsTemplate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/delete/sms/template'
			},
			createSmsTemplate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/add/sms/template'
			},
			updateSmsTemplate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/update/sms/template'
			},
			
		};
	}
}

export default new APIS();
